// Aviso por email a los participantes con el PIN. El servidor monta el texto con el
// titulo y las fechas del diagnostico; aqui solo se mandan los emails y el PIN.
export const sendPinEmails = async ({ emails, pin, language }) => {
  const list = [...new Set((Array.isArray(emails) ? emails : [])
    .filter((email) => typeof email === 'string' && email.trim())
    .map((email) => email.trim()))];
  if (!list.length || !pin) return;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/send-pin-emails`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
      body: JSON.stringify({ emails: list, pin, language })
    });
    if (!response.ok) console.error('Error al enviar los correos:', response.status);
  } catch (error) {
    console.error('Error de red al enviar los correos:', error);
  }
};

export default sendPinEmails;
